import * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-10 w-full rounded-lg border border-[#EDC29C]/40 bg-[#161616] px-3 py-2 text-sm text-[#FAF1E9] placeholder:text-[#FAF1E9]/40 shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[#FAF1E9] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#EDC29C] focus-visible:ring-offset-2 focus-visible:ring-offset-[#161616] disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Input }
